import create, { GetState, SetState } from 'zustand';

export interface INotificationSSE {
  unReadCount: number;
  setNotificationSSE: (unReadCount: number) => void;
  getNotificationSSE: (unReadCount: number) => void;
}

export const useNotificationSSEStore = create<INotificationSSE>(
  (set: SetState<INotificationSSE>, get: GetState<INotificationSSE>) => ({
    unReadCount: 0,
    setNotificationSSE: (unCount: number) => set({ unReadCount: unCount }),
    getNotificationSSE: () => get().unReadCount,
  })
);
